import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const OverflowText = styled(Typography)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
